import { Tabs } from "antd";
import { Navigate } from "react-router-dom";
import HiringJobList from "./HiringJobList";
import HiringCandidateList from "./HiringCandidateList";
import HiringPipeline from "./HiringPipeline";
import HiringOfferList from "./HiringOfferList";

const Hiring = () => {
	const isLogged = Boolean(localStorage.getItem("isLogged"));

	if (!isLogged) {
		return <Navigate to="/admin/auth/login" replace />;
	}

	const tabItems = [
		{
			key: "jobs",
			label: "Job openings",
			children: <HiringJobList />,
		},
		{
			key: "candidates",
			label: "Candidates",
			children: <HiringCandidateList />,
		},
		{
			key: "pipeline",
			label: "Pipeline",
			children: <HiringPipeline />,
		},
		{
			key: "offers",
			label: "Offers",
			children: <HiringOfferList />,
		},
	];

	return <Tabs defaultActiveKey="jobs" items={tabItems} />;
};

export default Hiring;
